import ApiService from "./Api.service.js";

class LessonService extends ApiService {
  changeMeetingStatus(lessonId) {
    return this.resource.put(`lessons/changeMeetingStatus/${lessonId}`, {});
  }
  toogleLessonMeetingAtive(lessonId) {
    return this.resource.put(
      `lessons/toogleLessonMeetingAtive/${lessonId}`,
      {}
    );
  }
  changeTheStatusOfTheLessonService(userId, moduleId, lessonId) {
    return this.resource.put(`user/${userId}/module/${moduleId}/changeTheStatusOfTheLesson/${lessonId}`);
  }

  deleteLesson(userId, moduleId, lessonId) {
    return this.resource.put(`user/${userId}/module/${moduleId}/lessons/${lessonId}/delete`);
  }

  storeLesson(userId, moduleId, lessonId, lesson) {
    return this.resource.post(`user/${userId}/module/${moduleId}/lessons/${lessonId}/store`, lesson);
  }

}

export default new LessonService("lessons");



// WEBPACK FOOTER //
// ./src/services/axios/lesson.service.js